import React from "react";
import "./join.css";
import { useRef } from "react";
import emailjs from "@emailjs/browser";
const Join = () => {
    const form=useRef();
    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_uiii38f', 'template_j6zkcor', form.current, 'J4PK6P45iy3vjAMDd')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
      };
  return (
    <div className="join" id="join-us">
      <div className="join-l">
      <hr />
        <div>
          <span className="stroke-text">READY TO</span>
          <span> LEVEL UP</span>
        </div>
        <div>
          <span>YOUR BODY</span>
          <span className="stroke-text"> WITH US?</span>
        </div>
      </div>
      <div className="join-r">
        <form ref={form} action="" className="email-container" onSubmit={sendEmail}>
            <input type="email" name="user_email" id="" placeholder="Enter Your E-mail"  />
            <button className="btn btn-j">Join Now</button>
        </form>
      </div>
    </div>
  );
};

export default Join;
